module.exports = __webpack_public_path__ + "static/media/vallea.39b336c7.svg";